import { GameBackside, GameHolder } from '@pascal/pascal-core/table-line';
import { FreeBetsWrapper } from '@pascal/pascal-core';
import { GameLeftInner } from '../../containers/gameLeftInner';
import { GameContent } from '../../containers/gameContent';

export function WebGameMain() {
  return (
    <GameHolder>
      <GameBackside />
      <div className='turbo-belote-web-wrapper'>
        <div className='turbo-belote-web-left-cl'>
          <GameLeftInner />
        </div>
        <GameContent />
        <FreeBetsWrapper />
      </div>
    </GameHolder>
  );
}
